import * as React from "react";
import { Upload } from "lucide-react";
import { cn } from "@/lib/class-control";

interface FileUploadInputProps {
  label: string;
  onChange: (file: File | null) => void;
  accept?: string;
  value?: File | null;
  className?: string;
}

export function FileUploadInput({
  label,
  onChange,
  accept = ".jpg,.jpeg,.png,.pdf",
  value,
  className,
}: FileUploadInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    onChange(file);
  };

  return (
    <div className={cn("flex flex-col gap-[18px]", className)}>
      <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
        {label}
      </label>
      <label className="bg-[#15203c] border border-[#5d5d5d] flex items-center gap-[22px] h-[59px] px-[20px] py-[10px] rounded-[10px] cursor-pointer hover:border-[#7846ff] transition-colors">
        <Upload className="w-[24px] h-[24px] text-[#d1d1d1]" />
        <span className="font-['Plus_Jakarta_Sans'] font-normal text-[14px] text-[#d1d1d1] leading-normal">
          {value ? value.name : "Faça upload (JPG, PDF, PNG)"}
        </span>
        <input
          type="file"
          onChange={handleChange}
          accept={accept}
          className="hidden"
        />
      </label>
    </div>
  );
}
